import { createSlice } from "@reduxjs/toolkit";
import {
  addUser,
  deleteUser,
  getAllUsers,
  getUserDetails,
  updateUser,
  updateUserStatus,
} from "store/actions/userSlice";

const initialState = {
  isLoading: false,
  loading: false,
  perPage: 50,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  users: [],
  userDetails: {},
  gettingDetails: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        const { data, totalCount, totalPages, currentPage } =
          action.payload || {};
        if (success) {
          state.users = data;
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getUserDetails.pending, (state) => {
        state.gettingDetails = true;
      })
      .addCase(getUserDetails.fulfilled, (state, action) => {
        state.gettingDetails = false;
        state.userDetails = {};
        const { success, data } = action.payload || {};
        if (success) {
          state.userDetails = data;
        }
      })
      .addCase(getUserDetails.rejected, (state, action) => {
        state.gettingDetails = true;
      });

    builder
      .addCase(addUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.users.push(data);
        }
      })
      .addCase(addUser.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.users = state?.users?.map((item) =>
            item._id === data._id ? data : item
          );
        }
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(deleteUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        const { success } = action.payload;
        const { id } = action.meta.arg;
        state.isLoading = false;
        if (success) {
          state.users = state.users.filter((item) => item._id !== id);
          if (state.totalCount !== null) {
            state.totalCount -= 1;
          }
        }
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateUserStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUserStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { id, status } = action.meta.arg;
          state.users = state?.users?.map((item) =>
            item._id === id ? { ...item, status: status } : item
          );
        }
      })
      .addCase(updateUserStatus.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default userSlice.reducer;
